interface TierNameRecord {
  name?: string | null;
  name_en?: string | null;
  [key: string]: any;
}

export const getTierNameByLocale = (
  tier: TierNameRecord | null | undefined,
  resolvedLanguage?: string | null
): string => {
  const locale = (resolvedLanguage || 'en').toLowerCase().replace('-', '_');
  const language = locale.split('_')[0];

  return (
    tier?.[`name_${locale}`] ?? tier?.[`name_${language}`] ?? tier?.name_en ?? tier?.name ?? ''
  );
};
